var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMessageMini = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    id: "Icon",
    d: "M11 5.75001C11.0017 6.40995 10.8475 7.06096 10.55 7.65001C10.1972 8.35589 9.65488 8.9496 8.98372 9.36465C8.31257 9.77971 7.53912 9.99971 6.75 10C6.09007 10.0017 5.43906 9.84755 4.85 9.55001L2 10.5L2.95 7.65001C2.65247 7.06096 2.49828 6.40995 2.5 5.75001C2.50031 4.96089 2.72031 4.18744 3.13536 3.51629C3.55041 2.84514 4.14413 2.3028 4.85 1.95001C5.43906 1.65248 6.09007 1.49829 6.75 1.50001H7C8.04217 1.55751 9.02652 1.99739 9.76457 2.73544C10.5026 3.47349 10.9425 4.45784 11 5.50001V5.75001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessageMini, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message-mini.605a1455.svg";
export { ForwardRef as ReactComponent };